import backofficeService from '../../../api/backoffice'

export default {
  /**
   * Get list of categories
   * @param {*} params
   * @param {*} params.limit
   * @param {*} params.offset
   * @param {*} params.search
   * @param {*} params.local Add LocalData to categories
   */
  getAll(params) {
    return backofficeService.Api().get('api/reconcile', { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  getByStoreID(id, params) {
    return backofficeService.Api().get(`api/reconcile/ByStoreID/${id}`, { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },

  create(data) {
    return backofficeService.Api().post('api/reconcile', data)
      .then(response => {
        console.log('response', response)
        return response.data
      })
      .catch((error) => { throw error })
  },
  /**
   * Update specific category
   * @param {*} id
   * @param {*} data
   */
  update(storeID, serviceID, data) {
    return backofficeService.Api().put(`crm/api/update/productRelation/${storeID}/${serviceID}`, data)
      .then(response => response.data)
      .catch((error) => { throw error })
  },
}
